import { Button } from "../../components/ui/Button";
import { HiOutlineCalendar, HiOutlineCash, HiOutlineUser } from "react-icons/hi";
import { MdOutlinePercent } from "react-icons/md";

export const Advantages = ({onGoToRegister}) => (
    <section id="AdvantagesFgts" className="bg-white py-16 px-6 max-w-7xl mx-auto text-center">
        <span className="inline-block bg-orange-100 text-orange-600 text-xs font-semibold rounded-full px-4 py-1 mb-4">
            Vantagens
        </span>

        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 max-w-xl mx-auto leading-relaxed mb-4">
            O que é antecipação do Saque-Aniversário do FGTS Bmg?
        </h2>

        <p className="text-gray-600 max-w-xl mx-auto mb-12 leading-relaxed">
            É uma modalidade de crédito que possibilita você antecipar de 5 até 10
            anos de parcela do seu Saque-Aniversário anualmente na conta vinculada
            do FGTS com a menor taxa de juros.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 max-w-5xl mx-auto mb-12 text-left">
            <div className="border border-gray-200 rounded-lg p-6 flex flex-col gap-2">
                <HiOutlineCalendar className="text-orange-500 w-6 h-6 mb-2" />
                <h3 className="font-semibold text-gray-800 mb-1">Sem parcelas mensais</h3>
                <p className="text-gray-600 text-sm">
                    O valor é descontado direto do seu FGTS sem comprometer sua renda.
                </p>
            </div>

            <div className="border border-gray-200 rounded-lg p-6 flex flex-col gap-2">
                <MdOutlinePercent className="text-orange-500 w-6 h-6 mb-2" />
                <h3 className="font-semibold text-gray-800 mb-1">Taxa de juros mais atrativas</h3>
                <p className="text-gray-600 text-sm">
                    Juros a partir de 1,29% ao mês. Custo efetivo total de 1,59% ao mês e 21,15% ao ano.
                </p>
            </div>

            <div className="border border-gray-200 rounded-lg p-6 flex flex-col gap-2">
                <HiOutlineCash className="text-orange-500 w-6 h-6 mb-2" />
                <h3 className="font-semibold text-gray-800 mb-1">Dinheiro na conta rápido</h3>
                <p className="text-gray-600 text-sm">
                    liberação em até 48 horas em dias úteis, condicionado a formalização e análise.
                </p>
            </div>

            <div className="border border-gray-200 rounded-lg p-6 flex flex-col gap-2">
                <HiOutlineUser className="text-orange-500 w-6 h-6 mb-2" />
                <h3 className="font-semibold text-gray-800 mb-1">Você no controle</h3>
                <p className="text-gray-600 text-sm">
                    Viajar, investir e até quitar dívidas. Liberdade para usar o valor como quiser!
                </p>
            </div>
        </div>

        <Button onClick={onGoToRegister} variant="outline">
            Simular antecipação <span className="font-semibold">FGTS</span>
        </Button>
    </section>
);